import { Box, Button, Typography, useMediaQuery } from '@mui/material'
import React, { useCallback, useEffect, useRef, useState } from 'react'
import styles from './styles.module.css'
import BollywoodCasinoimg from '../../../images/BollywoodCasino/bollywood casino.png'
import ResultsScreen from './BetsTable/ResultsScreen';
import ChipComponent from './ChipComponent';
import { numberOrder, anglePerSlot, numberAngleMap, chips, blackNumbers } from './RouletteConstants';
import GameScreen from './GameScreen';
import useGameSocket from '../../../api/useGameSocket';
import { useDispatch, useSelector } from 'react-redux';
import { placeBetRoualete } from '../../../store/slices/betSlice';
import { showError, showSuccess } from '../../../utils/toast';
import { rouletteresult, roulettRebet } from '../../../store/slices/casinoResultsSlice';
import useRoundLoader from '../../../api/useRoundLoader';
import RoundLoader from '../../Loader/RoundLoader';
import useCasinoBetplace from '../../../api/useCasinoBetplace';

// Initialize numberAngleMap
numberOrder.forEach((num, index) => {
    numberAngleMap[num] = index * anglePerSlot;
});

const SvgRemove = (
    <svg xmlns="http://www.w3.org/2000/svg" width="10" height="9" viewBox="0 0 10 9" fill="none">
        <path d="M10 8.27368L9.19298 9L4.99649 5.22316L0.8 9L0 8.27368L4.19649 4.49684L0 0.72L0.8 0L4.99649 3.77684L9.19298 0L10 0.72L5.80351 4.49684L10 8.27368Z" fill="white" />
    </svg>
)

const SvgRebet = (
    <svg xmlns="http://www.w3.org/2000/svg" width="10" height="11" viewBox="0 0 10 11" fill="none">
        <path d="M0.5 6.46486C0.5 3.95688 2.51146 1.92971 5 1.92971C5.24499 1.92971 5.48997 1.9492 5.72206 1.99468L4.53582 0.812168C4.45845 0.721205 4.41332 0.604253 4.41332 0.480803C4.41332 0.214412 4.61318 0 4.86461 0C5.00645 0 5.12249 0.0519787 5.19986 0.142942L7.23711 2.22209C7.32092 2.30656 7.37249 2.43001 7.37249 2.55346C7.37249 2.6899 7.32736 2.80035 7.23711 2.89132L5.19986 4.94448C5.11605 5.02245 5.01289 5.07442 4.86461 5.07442C4.61318 5.07442 4.41332 4.87301 4.41332 4.60662C4.41332 4.48966 4.45201 4.36621 4.54226 4.28175L5.90903 2.9303C5.63825 2.87183 5.33524 2.85883 5 2.85883C3.02722 2.85883 1.42837 4.47017 1.42837 6.45836C1.42837 8.44654 3.02722 10.0514 5 10.0514C6.97278 10.0514 8.57163 8.44654 8.57163 6.45836C8.57163 6.17247 8.7457 5.97106 9.01648 5.97106C9.30014 5.97106 9.5 6.17247 9.5 6.46486C9.5 8.96633 7.48854 11 5 11C2.51146 11 0.5 8.96633 0.5 6.46486Z" fill="white" />
    </svg>
)

const SvgUndo = (
    <svg xmlns="http://www.w3.org/2000/svg" width="14" height="7" viewBox="0 0 14 7" fill="none">
        <path d="M2.52837 7L2.15957 6.92798C1.89615 5.71811 1.34296 4.50823 0.5 3.25514L0.671226 2.43416C1.47467 3.12551 2.0542 3.75926 2.43617 4.32099C3.16059 1.81481 5.29433 0 7.83637 0C10.9711 0 13.5 2.76543 13.5 6.19342H12.5648C12.5648 3.32716 10.4574 1.02263 7.83637 1.02263C5.75532 1.02263 3.99037 2.49177 3.35816 4.53704C3.89818 4.22016 4.68845 3.9321 5.66312 3.70165L5.47872 4.50823C4.24063 5.2428 3.25279 6.07819 2.52837 7Z" fill="white" />
    </svg>
)

const SvgDouble = (
    <svg xmlns="http://www.w3.org/2000/svg" width="13" height="8" viewBox="0 0 13 8" fill="none">
        <path d="M0.550336 8V7.32837L3.00671 4.46852C3.93289 3.39066 4.2047 2.98443 4.2047 2.30196V2.29113C4.2047 1.46784 3.68624 0.850372 2.83054 0.850372C1.95973 0.850372 1.38087 1.46242 1.38087 2.38321L1.37584 2.39404L0.510067 2.38863L0.5 2.38321C0.505034 0.996615 1.50168 0 2.89094 0C4.1594 0 5.13087 0.926202 5.13087 2.18822V2.19905C5.13087 3.09276 4.77349 3.74272 3.45973 5.19973L1.80872 7.03588V7.12255H5.25168V8H0.550336Z" fill="white" />
        <path d="M6.4094 8L8.88591 4.07312V4.05146L6.4396 0.184157H7.53188L9.47483 3.33108H9.50503L11.4681 0.184157H12.5L9.98825 4.1002V4.12187L12.4446 8H11.3574L9.4245 4.88016H9.3943L7.43624 8H6.4094Z" fill="white" />
    </svg>
)

const areaNeighbors = {
    column1: { right: 'column2' },
    column2: { left: 'column1', right: 'column3' },
    column3: { left: 'column2' },
    dozen1: { right: 'dozen2' },
    dozen2: { left: 'dozen1', right: 'dozen3' },
    dozen3: { left: 'dozen2' },
    low: { right: 'even' },
    even: { left: 'low', right: 'red' },
    red: { left: 'even', right: 'black' },
    black: { left: 'red', right: 'odd' },
    odd: { left: 'black', right: 'high' },
    high: { left: 'odd' },
};



function Roulette({ onBetSelect }) {
    const isLargeScreen = useMediaQuery("(min-width:1024px)");
    const dispatch = useDispatch();
    const userId = useSelector((state) => state.auth.userId);
    const [betDialogOpen, setBetDialogOpen] = useState(false);
    const [selectedBet, setSelectedBet] = useState(null);
    const [isAnimationStarted, setIsAnimationStarted] = useState(false);
const [forceHideChips, setForceHideChips] = useState(false);
  const [selectedChip, setSelectedChip] = useState(
    chips.find(chip => chip.value === 10)?.value || chips[0]?.value || null
);

    const [gameStarted, setGameStarted] = useState(false);

    const [timer, setTimer] = useState(30);
    const [locked, setLocked] = useState(false);
    const [bets, setBets] = useState([]);
    const [rotation, setRotation] = useState(0);

    const { socketData, connected } = useGameSocket();
const resultNumber = socketData?.settlement?.resultNumber;

    const roundId = socketData?.roundId
        const showLoader = useRoundLoader(roundId);
const isResultWindow =
  Boolean(socketData?.bettingClosed) &&
  socketData?.settlement?.resultTime != null;

const visibleBets = isResultWindow
  ? []
  : bets.filter(
      (b) =>
        !b.roundId ||
        Number(b.roundId) === Number(socketData?.roundId)
    );


const { bets: serverBets } = useCasinoBetplace(
  3,                    // gameId
  socketData,
  socketData?.roundId
);
    useEffect(() => {
        if (socketData?.bettingClosed !== undefined) {
            setLocked(socketData.bettingClosed);
            if (!socketData.bettingClosed) {
                setIsAnimationStarted(false);
            }
        }
    }, [socketData?.bettingClosed]);



useEffect(() => {
  if (!userId) return;
  if (!Array.isArray(serverBets) || serverBets.length === 0) return;
  if (isResultWindow) return; 

  const currentRound = socketData?.roundId;
  if (!currentRound) return;

  const restored = serverBets
    .filter((b) => Number(b.userId) === Number(userId))
    .filter((b) => !b.roundId || Number(b.roundId) === Number(currentRound))
    .map((b, idx) => mapServerBetToLocal(b, idx))
    .filter(Boolean);

  // agar bets already locally present hain (submit ke turant baad), overwrite mat karo
  setBets((prev) => {
    if (prev.length > 0 && isSubmittedRef.current) return prev;
    return restored.length > 0 ? restored : prev;
  });

  if (restored.length > 0) {
    isSubmittedRef.current = true;
  }
}, [serverBets, userId, socketData?.roundId, isResultWindow]);



    useEffect(() => {
        if (socketData?.remainingTime !== undefined) {
            setTimer(socketData.remainingTime);
        }
    }, [socketData?.remainingTime]);

    const handleChipClick = (value) => {
        if (!locked) {
            setSelectedChip(value);
        }
    };

    const rebet = useSelector((state)=>state.casinoResults.Rebet);


    useEffect(()=>{
        if(userId)
        {
            dispatch(roulettRebet(userId))
        }
    },[dispatch,userId])





     const isSubmittedRef = useRef(false);
    const zero = ["0"];
    const twoToOne = ["2to1", "2to1", "2to1"];
    const dozens = [
        { top: "1st", bottom: "12" },
        { top: "2nd", bottom: "12" },
        { top: "3rd", bottom: "12" },
    ];
    const row3 = ["1 to 18", "EVEN"];
    const row4 = [
        { label: "RED", boxClass: styles.RowCellBox4Red, textClass: styles.RowCellBox4Text },
        { label: "BLACK", boxClass: styles.RowCellBox4Black, textClass: styles.RowCellBox4Text },
    ];
    const row5 = [
        { label: "ODD", boxClass: styles.RowCellBox5, textClass: styles.RowCellBox5Text },
        { label: "19 to 36", boxClass: styles.RowCellBox5, textClass: styles.RowCellBox5Text },
    ];

    const numbers = Array.from({ length: 36 }, (_, i) => i + 1);
    const chunkedNumbers = [];
    for (let i = 0; i < numbers.length; i += 3) {
        chunkedNumbers.push(numbers.slice(i, i + 3));
    }

    const outsideAreas = {
        zero: { numbers: [0] },
        column1: { numbers: numbers.filter(n => n % 3 === 1) },
        column2: { numbers: numbers.filter(n => n % 3 === 2) },
        column3: { numbers: numbers.filter(n => n % 3 === 0) },
        dozen1: { numbers: numbers.slice(0, 12) },
        dozen2: { numbers: numbers.slice(12, 24) },
        dozen3: { numbers: numbers.slice(24, 36) },
        low: { numbers: numbers.slice(0, 18) },
        even: { numbers: numbers.filter(n => n % 2 === 0) },
        red: { numbers: numbers.filter(n => !blackNumbers.includes(n)) },
        black: { numbers: blackNumbers },
        odd: { numbers: numbers.filter(n => n % 2 === 1) },
        high: { numbers: numbers.slice(18, 36) },
    };

    const outsideAreaMap = {
        RED: 'red', BLACK: 'black', ODD: 'odd', EVEN: 'even',
        LOW: 'low', HIGH: 'high',
        DOZEN_1ST: 'dozen1', DOZEN_2ND: 'dozen2', DOZEN_3RD: 'dozen3',
        COLUMN_1: 'column1', COLUMN_2: 'column2', COLUMN_3: 'column3',
    };

    const positionMap = {
        STRAIGHT: 'center',
        SPLIT: 'split-h',
        STREET: 'street',
        CORNER: 'corner',
        SIX_LINE: 'line',
    };
const mapServerBetToLocal = (b, index) => {
    // choice null / undefined / empty → empty array
    const rawChoice = b.choice;
    const numbers = (
        typeof rawChoice === 'string' && rawChoice.trim() !== ''
            ? rawChoice.split(',').map(Number).filter((n) => !isNaN(n))
            : []
    ).sort((a, c) => a - c);

    const id = `bet-${b.betId ?? Date.now()}-${index}`;
    const amount = Number(b.stake) || 0;

    // ---------- ZERO ----------
    if (b.selection === 'STRAIGHT' && (b.choice === '0' || b.choice === 0)) {
        return {
            id,
            type: 'outside',
            area: 'zero',
            numbers: [0],
            position: 'center',
            placement: 'center',
            amount,
        };
    }

    // ---------- OUTSIDE BETS (RED, BLACK, DOZEN, COLUMN, etc.) ----------
    if (outsideAreaMap[b.selection]) {
        const area = outsideAreaMap[b.selection];
        return {
            id,
            type: 'outside',
            area,
            numbers: outsideAreas[area]?.numbers || [],
            position: 'center',
            placement: 'center',
            amount,
        };
    }

    // ---------- STRAIGHT ----------
    if (b.selection === 'STRAIGHT') {
        if (numbers.length === 0) {
            console.warn('STRAIGHT without valid choice', b);
            return null;
        }
        return {
            id,
            type: 'inside',
            numbers,
            position: 'center',
            anchor: 'center',
            clickedNum: numbers[0],
            amount,
        };
    }

    // Agar numbers empty hain (choice: null) → skip
    if (numbers.length === 0) {
        console.warn('Inside bet without numbers, skipping', {
            selection: b.selection,
            choice: b.choice,
            betId: b.betId,
        });
        return null;
    }

    const smallest = numbers[0];
    const col = (smallest - 1) % 3;

    let position = 'center';
    let anchor = 'center';
    let clickedNum = smallest;

    // ---------- SPLIT ----------
    if (b.selection === 'SPLIT' && numbers.length === 2) {
        const diff = numbers[1] - numbers[0];
        if (diff === 1) {
            // horizontal split (same street)
            position = 'split-h';
            anchor = col === 2 ? 'left' : 'right';
            clickedNum = col === 2 ? numbers[1] : numbers[0];
        } else if (diff === 3) {
            // vertical split
            position = 'split-v';
            anchor = 'bottom';
            clickedNum = numbers[0];
        }
    }
    // ---------- STREET ----------
    else if (b.selection === 'STREET' && numbers.length === 3) {
        position = 'street';
        anchor = 'bottom-center';
        clickedNum = numbers[1];
    }
    // ---------- CORNER ----------
    else if (b.selection === 'CORNER' && numbers.length === 4) {
        position = 'corner';
        anchor = col === 2 ? 'bottom-left' : 'bottom-right';
        clickedNum = numbers[0];
    }
    // ---------- SIX_LINE ----------
    else if (b.selection === 'SIX_LINE' && numbers.length === 6) {
        position = 'line';
        anchor = 'bottom-left';
        clickedNum = numbers[0];
    }
    // ---------- unknown / incomplete ----------
    else {
        console.warn('Unhandled selection or incomplete numbers', {
            selection: b.selection,
            numbers,
            choice: b.choice,
        });
        // fallback: pehle number pe straight jaisa dikhao
        return {
            id,
            type: 'inside',
            numbers,
            position: 'center',
            anchor: 'center',
            clickedNum: numbers[0],
            amount,
        };
    }

    return {
        id,
        type: 'inside',
        numbers,
        position,
        anchor,
        clickedNum,
        amount,
    };
};
    useEffect(() => {
        if (isAnimationStarted || socketData?.remainingTime !== undefined) return;

        const countdown = setInterval(() => {
            setTimer((prev) => {
                if (prev <= 1) {
                    clearInterval(countdown);
                    setLocked(true);
                    setIsAnimationStarted(true);
                    return 0;
                }
                return prev - 1;
            });
        }, 1000);

        return () => clearInterval(countdown);
    }, [isAnimationStarted, socketData?.remainingTime]);

    const handleStageComplete = () => {
        setIsAnimationStarted(false);
        setLocked(false);
        setTimer(30);
    };

    const smoothResetRotation = (callback) => {
        const startAngle = rotation;
        const targetAngle = Math.ceil(startAngle / 360) * 360;
        const duration = 3000;
        const startTime = performance.now();

        const easeOutCubic = (t) => 1 - Math.pow(1 - t, 3);

        const animate = (time) => {
            const elapsed = time - startTime;
            const progress = Math.min(elapsed / duration, 1);
            const eased = easeOutCubic(progress);
            const current = startAngle + (targetAngle - startAngle) * eased;

            setRotation(current);

            if (progress < 1) {
                requestAnimationFrame(animate);
            } else if (callback) {
                callback();
            }
        };

        requestAnimationFrame(animate);
    };

    const [hoverPosition, setHoverPosition] = useState(null);


    const getSelectionAndChoice = (bet) => {
   
        if (bet.area) {
            const areaMap = {
                zero:    { selection: 'STRAIGHT',  choice: '0' },
                red:     { selection: 'RED',        choice: 'RED' },
                black:   { selection: 'BLACK',      choice: 'BLACK' },
                odd:     { selection: 'ODD',        choice: 'ODD' },
                even:    { selection: 'EVEN',       choice: 'EVEN' },
                low:     { selection: 'LOW',        choice: 'LOW' },
                high:    { selection: 'HIGH',       choice: 'HIGH' },
                dozen1:  { selection: 'DOZEN_1ST',  choice: 'DOZEN_1ST' },
                dozen2:  { selection: 'DOZEN_2ND',  choice: 'DOZEN_2ND' },
                dozen3:  { selection: 'DOZEN_3RD',  choice: 'DOZEN_3RD' },
                column1: { selection: 'COLUMN_1',   choice: 'COLUMN_1' },
                column2: { selection: 'COLUMN_2',   choice: 'COLUMN_2' },
                column3: { selection: 'COLUMN_3',   choice: 'COLUMN_3' },
            };
            return areaMap[bet.area] || { selection: 'STRAIGHT', choice: bet.area };
        }

      
        const choice = bet.numbers.join(',');
        switch (bet.position) {
            case 'center':   return { selection: 'STRAIGHT', choice };
            case 'split-h':
            case 'split-v':  return { selection: 'SPLIT',    choice };
            case 'street':   return { selection: 'STREET',   choice };
            case 'corner':   return { selection: 'CORNER',   choice };
            case 'line':     return { selection: 'SIX_LINE', choice };
            default:         return { selection: 'STRAIGHT', choice };
        }
    };

 document.addEventListener('click', (e) => {

}, { once: true });


const handleSubmitAllBets = useCallback(async () => {

  const pendingBets = bets.filter((b) => !b.betId);
  if (pendingBets.length === 0) return;
  if (isSubmittedRef.current) return;
  isSubmittedRef.current = true;

  try {
    const betsPayload = pendingBets.map((bet) => {
      const { selection, choice } = getSelectionAndChoice(bet);
      return {
        betType: 'BACK',
        selection,
        choice,
        stake: bet.amount,
      };
    });

    await dispatch(
      placeBetRoualete({
        userId: parseInt(userId, 10),
        roundId: parseInt(socketData?.roundId, 10),
        bets: betsPayload,
      })
    ).unwrap();

dispatch(rouletteresult());
  } catch (err) {
    isSubmittedRef.current = false;
    const backendMessage = err?.message || err?.error || 'Bet failed';
    showError(backendMessage);
    setBets([]);
  }
}, [bets, userId, socketData?.roundId, dispatch]);
useEffect(() => {
    if (isResultWindow) {
        setBets([]);          
        dispatch(rouletteresult());
    }
}, [isResultWindow, dispatch]);
useEffect(() => {
    if ((socketData?.remainingTime === 0 || timer === 0) && bets.length > 0) {
        handleSubmitAllBets();
    }
}, [socketData?.remainingTime, timer, handleSubmitAllBets]); 

useEffect(() => {
    if (socketData?.bettingClosed === true && bets.length > 0) {
        handleSubmitAllBets();
    }
}, [socketData?.bettingClosed, handleSubmitAllBets]); 

// Naye round pe reset
useEffect(() => {
    if (socketData?.bettingClosed === false) {
        isSubmittedRef.current = false;
    }
}, [socketData?.bettingClosed]);;

  


    const getBetPosition = (e, numOrArea) => {
        const rect = e.target.getBoundingClientRect();
        const x = e.clientX - rect.left;
        const y = e.clientY - rect.top;
        const relX = x / rect.width;
        const relY = y / rect.height;
        const T = 0.18;

        if (typeof numOrArea === 'number') {
            const num = numOrArea;
            if (num === 0) return { numbers: [0], position: 'center' };

            const col      = (num - 1) % 3;
            const groupRow = Math.floor((num - 1) / 3);

 if (!isLargeScreen) {
    // Row-major grid: 1,4,7 same row; col = row-position, groupRow = column-position
    const col      = Math.floor((num - 1) / 3);   // horizontal group (0..11)
    const groupRow = (num - 1) % 3;                 // vertical position within group (0,1,2)

    // Corners
    if (relX > (1 - T) && relY > (1 - T) && col < 11 && groupRow < 2)
        return { numbers: [num, num + 1, num + 3, num + 4], position: 'corner', anchor: 'bottom-right' };
    if (relX < T && relY > (1 - T) && col > 0 && groupRow < 2)
        return { numbers: [num - 3, num - 2, num, num + 1], position: 'corner', anchor: 'bottom-left' };
    if (relX > (1 - T) && relY < T && col < 11 && groupRow > 0)
        return { numbers: [num - 1, num, num + 2, num + 3], position: 'corner', anchor: 'top-right' };
    if (relX < T && relY < T && col > 0 && groupRow > 0)
        return { numbers: [num - 4, num - 3, num - 1, num], position: 'corner', anchor: 'top-left' };

    // Split — horizontal (same row, next group) = num ± 3
    if (relX > (1 - T) && col < 11)
        return { numbers: [num, num + 3], position: 'split-v', anchor: 'right' };
    if (relX < T && col > 0)
        return { numbers: [num - 3, num], position: 'split-v', anchor: 'left' };

    // Split — vertical (same group, adjacent row) = num ± 1
    if (relY > (1 - T) && groupRow < 2)
        return { numbers: [num, num + 1], position: 'split-h', anchor: 'bottom' };
    if (relY < T && groupRow > 0)
        return { numbers: [num - 1, num], position: 'split-h', anchor: 'top' };

    // Street (full 3 numbers in a group)
    if (relX > (1 - T) && col === 11)
        return { numbers: [num - groupRow, num - groupRow + 1, num - groupRow + 2], position: 'street', anchor: 'right-center' };

    // Six-line (two adjacent groups)
    if (relX > (1 - T) && col < 11 && groupRow === 0)
        return { numbers: [num, num + 1, num + 2, num + 3, num + 4, num + 5], position: 'line', anchor: 'right-top' };

    // Straight
    return { numbers: [num], position: 'center' };

} else {
    // CORNER — 4 numbers, click near center intersection
    if (relX > (1-T) && relY > (1-T) && col < 2 && groupRow < 11)
        return { numbers: [num, num+1, num+3, num+4], position: 'corner', anchor: 'bottom-right' };
    if (relX < T && relY > (1-T) && col > 0 && groupRow < 11)
        return { numbers: [num-1, num, num+2, num+3], position: 'corner', anchor: 'bottom-left' };
    if (relX > (1-T) && relY < T && col < 2 && groupRow > 0)
        return { numbers: [num-3, num-2, num, num+1], position: 'corner', anchor: 'top-right' };
    if (relX < T && relY < T && col > 0 && groupRow > 0)
        return { numbers: [num-4, num-3, num-1, num], position: 'corner', anchor: 'top-left' };

if (relX > (1-T) && col < 2)
    return { numbers: [num, num+3], position: 'split-v', anchor: 'right' };
if (relX < T && col > 0)
    return { numbers: [num-3, num], position: 'split-v', anchor: 'left' };

if (relY > (1-T) && groupRow < 2)
    return { numbers: [num, num+1], position: 'split-h', anchor: 'bottom' };
if (relY < T && groupRow > 0)
    return { numbers: [num-1, num], position: 'split-h', anchor: 'top' };

    // STREET — 3 numbers, end of row
    if (relY > (1-T) && groupRow === 2)
        return { numbers: [num-col, num-col+1, num-col+2], position: 'street', anchor: 'bottom-center' };
    if (relY < T && groupRow === 0)
        return { numbers: [num-col, num-col+1, num-col+2], position: 'street', anchor: 'top-center' };

    // LINE — 6 numbers, two rows
    if (relY > (1-T) && groupRow === 2 && col === 0)
        return { numbers: [num, num+1, num+2, num+3, num+4, num+5], position: 'line', anchor: 'bottom-left' };

    // STRAIGHT
    return { numbers: [num], position: 'center' };
    console.log({ num, relX: relX.toFixed(2), relY: relY.toFixed(2), col, groupRow });
}

        } else {
      
            const left  = areaNeighbors[numOrArea]?.left  || null;
            const right = areaNeighbors[numOrArea]?.right || null;

            if (relX > (1-T) && right)
                return {
                    numbers: outsideAreas[numOrArea].numbers.concat(outsideAreas[right].numbers),
                    position: 'split-h', anchor: 'right',
                };
            if (relX < T && left)
                return {
                    numbers: outsideAreas[numOrArea].numbers.concat(outsideAreas[left].numbers),
                    position: 'split-h', anchor: 'left',
                };

            return { numbers: outsideAreas[numOrArea].numbers, position: 'center' };
        }
    };


    const renderBetChip = (bet, num) => {
        if (bet.type !== 'inside' || !bet.numbers.includes(num)) return null;
          const chip = chips.reduce((prev, curr) => 
        Math.abs(curr.value - bet.amount) < Math.abs(prev.value - bet.amount) ? curr : prev
    );
        if (!chip) return null;

const anchorNum = bet.numbers[0];
if (num !== anchorNum) return null;

        const H = (chip.width || 16) / 2;
        const base = { position: 'absolute', zIndex: 10, pointerEvents: 'none' };

        let sx;

     switch (bet.position) {
    case 'center':
        sx = { ...base, top: '50%', left: '50%', transform: 'translate(-50%, -50%)' };
        break;
case 'split-v':
    if (bet.anchor === 'right') {
        sx = { ...base, right: `-${H}px`, top: '50%', transform: 'translateY(-50%)' };
    } else {
        sx = { ...base, left: `-${H}px`, top: '50%', transform: 'translateY(-50%)' };
    }
    break;
case 'split-h':
    if (bet.anchor === 'bottom') {
        sx = { ...base, bottom: `-${H}px`, left: '50%', transform: 'translateX(-50%)' };
    } else {
        sx = { ...base, top: `-${H}px`, left: '50%', transform: 'translateX(-50%)' };
    }
    break;
    case 'corner':
        if (bet.anchor === 'bottom-right') {
            sx = { ...base, right: `-${H}px`, bottom: `-${H}px` };
        } else if (bet.anchor === 'bottom-left') {
            sx = { ...base, left: `-${H}px`, bottom: `-${H}px` };
        } else if (bet.anchor === 'top-right') {
            sx = { ...base, right: `-${H}px`, top: `-${H}px` };
        } else {
            sx = { ...base, left: `-${H}px`, top: `-${H}px` };
        }
        break;
    case 'street':
        if (bet.anchor === 'right-center') {
            sx = { ...base, right: `-${H}px`, top: '50%', transform: 'translateY(-50%)' };
        } else if (bet.anchor === 'left-center') {
            sx = { ...base, left: `-${H}px`, top: '50%', transform: 'translateY(-50%)' };
        } else if (bet.anchor === 'bottom-center') {
            sx = { ...base, bottom: `-${H}px`, left: '50%', transform: 'translateX(-50%)' };
        } else if (bet.anchor === 'top-center') {
            sx = { ...base, top: `-${H}px`, left: '50%', transform: 'translateX(-50%)' };
        } else {
            sx = { ...base, top: `-${H}px`, left: '50%', transform: 'translateX(-50%)' };
        }
        break;
    case 'line':
        if (bet.anchor === 'right-top') {
            sx = { ...base, right: `-${H}px`, top: `-${H}px` };
        } else if (bet.anchor === 'right-bottom') {
            sx = { ...base, right: `-${H}px`, bottom: `-${H}px` };
        } else if (bet.anchor === 'bottom-left') {
            sx = { ...base, bottom: `-${H}px`, left: `-${H}px` };
        } else if (bet.anchor === 'bottom-right') {
            sx = { ...base, bottom: `-${H}px`, right: `-${H}px` };
        } else {
            sx = { ...base, top: `-${H}px`, left: `-${H}px` };
        }
        break;
    default:
        sx = { ...base, top: '50%', left: '50%', transform: 'translate(-50%, -50%)' };
}

        return (
            <Box key={bet.id} sx={sx}>
                <ChipComponent
                 value={bet.amount}
                    color={chip.color}
                    size="render"
                    chipWidth={chip.width}
                    chipHeight={chip.height}
                />
            </Box>
        );
    };


    const renderOutsideChip = (bet, area) => {
        if (bet.type !== 'outside' || bet.area !== area) return null;
        const chip = chips.reduce((prev, curr) => 
        Math.abs(curr.value - bet.amount) < Math.abs(prev.value - bet.amount) ? curr : prev
    )
        if (!chip) return null;

        const H = chip.width / 2 || 8;
        const base = { position: 'absolute', zIndex: 10, pointerEvents: 'none' };

        let sx;
        switch (bet.placement) {
            case 'right':
                sx = { ...base, right: `-${H}px`, top: '50%', transform: 'translateY(-50%)' };
                break;
            case 'left':
                sx = { ...base, left: `-${H}px`, top: '50%', transform: 'translateY(-50%)' };
                break;
            default:
                sx = { ...base, top: '50%', left: '50%', transform: 'translate(-50%, -50%)' };
        }

        return (
            <Box key={bet.id} sx={sx}>
                <ChipComponent
                    value={bet.amount}    
                    color={chip.color}
                    size="render"
                    chipWidth={chip.width}
                    chipHeight={chip.height}
                />
            </Box>
        );
    };

const handlePlaceBet = (e, num) => {
    if (locked) return;
    if (!selectedChip) { showError('please Select The Chip'); return; }

    const betPos = getBetPosition(e, num);
    const newBet = {
        ...betPos,
        amount: selectedChip,
        id: Date.now(),
        type: 'inside',

    };

    setBets(prev => {
        const key = betPos.numbers.slice().sort((a,b)=>a-b).join(',');
const existing = prev.find(b =>
    b.numbers.slice().sort((a,b)=>a-b).join(',') === key &&
    b.position === betPos.position
);
        if (existing) {
            return prev.map(b =>
                b.numbers.slice().sort((a,b)=>a-b).join(',') === key &&
                b.position === betPos.position
                    ? { ...b, amount: b.amount + selectedChip }
                    : b
            );
        }
        return [...prev, newBet];
    });

};


const handleOutsideBet = (e, area) => {
    if (locked || !selectedChip || !area) return;

    const rect = e.currentTarget.getBoundingClientRect();
    const relX = (e.clientX - rect.left) / rect.width;
    const T = 0.18;
    const left  = areaNeighbors[area]?.left  || null;
    const right = areaNeighbors[area]?.right || null;

    let placement = 'center';
    if (relX > (1 - T) && right) placement = 'right';
    else if (relX < T && left)   placement = 'left';

    const newBet = {
        numbers: outsideAreas[area].numbers,
        position: 'center',
        placement,
        amount: selectedChip,
        id: Date.now(),
        type: 'outside',
        area,
    };

    setBets(prev => {
        const existing = prev.find(b => b.area === area && b.placement === placement);
        if (existing) {
            return prev.map(b =>
                b.area === area && b.placement === placement
                    ? { ...b, amount: b.amount + selectedChip }
                    : b
            );
        }
        return [...prev, newBet];
    });
    
};

    const handleRemoveAll = () => {
        if (locked) return;
        setBets([]);
        
    };

const handleRebet = () => {
    if (locked) return;
    if (!rebet || rebet.length === 0) {
        showError('No previous bets to rebet');
        return;
    }

    const rebetBets = rebet.map((b, index) => mapServerBetToLocal(b, index));
    setBets(rebetBets);
};
useEffect(() => {
  if (!userId) return;
  if (socketData?.event !== 'BET_LIST') return;
  if (!Array.isArray(socketData?.bets)) return;
  if (isResultWindow || socketData?.bettingClosed) return;

  const restoredBets = socketData.bets
    .filter((b) => Number(b.userId) === Number(userId))
    .map((b, idx) => mapServerBetToLocal(b, idx))
    .filter(Boolean);

  console.log('BET_LIST restore', {
    count: restoredBets.length,
    userId,
    rawCount: socketData.bets.length,
  });

  // empty aaye to existing bets mat mitao
  if (restoredBets.length > 0) {
    setBets(restoredBets);
  }
}, [socketData?.event, socketData?.bets, userId]);
const currentRoundIdRef = useRef(null);
useEffect(() => {
  const incomingRoundId = socketData?.roundId;
  if (!incomingRoundId) return;

  if (currentRoundIdRef.current === null) {
    currentRoundIdRef.current = incomingRoundId;
    return;
  }

  if (Number(incomingRoundId) !== Number(currentRoundIdRef.current)) {
    setBets([]);
    isSubmittedRef.current = false;
    currentRoundIdRef.current = incomingRoundId;
  }
}, [socketData?.roundId]);
    const handleUndo = () => {
        if (locked) return;
        setBets(prev => prev.slice(0, -1));
     
    };

    const handleDouble = () => {
        if (locked) return;
        setBets(prev =>
            prev.map(bet => ({ ...bet, amount: bet.amount * 2 }))
        );
     
    };

    const totalBet = bets.reduce((acc, bet) => acc + bet.amount, 0);
   

    return (
        <RoundLoader showLoader={showLoader}>
        <Box className={styles.Main_Container}>
            {/* Video/Wheel Section */}
            <Box sx={{ position: 'relative', width: '100%' }}>
                <GameScreen
                    socketData={socketData}
                    resultNumber={resultNumber}
                />

                {/* Timer UI */}
                <Box className={styles.timer_container}>
                    <Box className={styles.timer_wrapper}>
                        {String(socketData?.remainingTime || timer)
                            .padStart(2, '0')
                            .split('')
                            .map((digit, index) => (
                                <Box key={index} className={styles.timer_box}>
                                    <Typography className={styles.timer_txt}>
                                        {digit}
                                    </Typography>
                                </Box>
                            ))}
                    </Box>
                </Box>

                  <Box className={styles.BlueContainer2}>
                    <Box
                        className={styles.BlueContainer2Boxes}
                        onClick={handleRemoveAll}
                        style={{ opacity: locked ? 0.5 : 1, cursor: locked ? 'not-allowed' : 'pointer' }}
                    >
                        <Box className={styles.BoxIcons}>{SvgRemove}</Box>
                        <Typography className={styles.BlueContainer1BoxText}>Remove</Typography>
                    </Box>

                    <Box
                        className={styles.BlueContainer2Boxes}
                        onClick={handleRebet}
                        style={{ opacity: locked ? 0.5 : 1, cursor: locked ? 'not-allowed' : 'pointer' }}
                    >
                        <Box className={styles.BoxIcons}>{SvgRebet}</Box>
                        <Typography className={styles.BlueContainer1BoxText}>Rebet</Typography>
                    </Box>

                    <Box
                        className={styles.BlueContainer2Boxes}
                        onClick={handleUndo}
                        style={{ opacity: locked ? 0.5 : 1, cursor: locked ? 'not-allowed' : 'pointer' }}
                    >
                        <Box className={styles.BoxIcons}>{SvgUndo}</Box>
                        <Typography className={styles.BlueContainer1BoxText}>Undo</Typography>
                    </Box>

                    <Box
                        className={styles.BlueContainer2Boxes}
                        onClick={handleDouble}
                        style={{ opacity: locked ? 0.5 : 1, cursor: locked ? 'not-allowed' : 'pointer' }}
                    >
                       
                      
                    </Box>
                </Box>

            </Box>

            {/* Blue Container */}
            <Box className={styles.BlueContainer}>
                <Box className={styles.BlueContainer1}>
                    <Box className={styles.BlueContainer1Inner}>
                        {/* <Box className={styles.BlueContainer1Box}>
                            <Typography className={styles.BlueContainer1BoxText}>
                                Total Bet: {totalBet}
                            </Typography>
                        </Box> */}
                        <Box className={styles.BlueContainer1Box}>
                            <Typography className={styles.BlueContainer1BoxText}>
                                Min Bet: 100 | Max Bet: 25000
                            </Typography>
                        </Box>
                    </Box>
                    {/* <Box>
                        <Typography className={styles.BlueContainer1BoxText}>
                            Last Win: 0
                        </Typography>
                    </Box> */}
                </Box>

                {/* Control Buttons */}
              
        
               {/* Chip Selection */}
<Box className={styles.BlueContainer3}>
    {chips.map((chip, index) => (
        <Box
            key={index}
            className={
                selectedChip === chip.value && !locked
                    ? styles.BlueContainer3InnerBig
                    : styles.BlueContainer3InnerSmall
            }
            onClick={() => handleChipClick(chip.value)}
            sx={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                cursor: locked ? 'not-allowed' : 'pointer',
                opacity: locked ? 0.5 : 1,
            }}
        >
            <ChipComponent
                value={chip.displayValue}  // ✅ bet.amount → chip.displayValue
                color={chip.color}
                size="render"
                chipWidth={chip.width}
                chipHeight={chip.height}
            />
        </Box>
    ))}
</Box>
 
            </Box>

            {/* Main Body */}
            <Box className={styles.BodyContainer}>
                {isLargeScreen ? (
                    <Box className={styles.MediaBox1}>
                        {/* Zero */}
                        <Box
                            className={styles.zeroBoxM}
                            onClick={(e) => handleOutsideBet(e, 'zero')}
                            sx={{
                                position: 'relative',
                                cursor: locked ? 'not-allowed' : 'pointer',
                                opacity: locked ? 0.7 : 1
                            }}
                        >
                            {zero.map((num, idx) => (
                                <Typography key={idx} className={styles.zeroText}>{num}</Typography>
                            ))}
                           {!isResultWindow && visibleBets.map((bet) => renderOutsideChip(bet, 'zero'))}
                            {locked && (
                                <Box className={styles.bettinglocked_icon_containerzeroBoxM}>
                                    <svg xmlns="http://www.w3.org/2000/svg" width="21" height="20" viewBox="0 0 21 20" fill="none">
                                        <path d="M17.1969 9.53979C16.9582 9.30113 16.6686 9.18189 16.3275 9.18189H15.9187V6.72721C15.9187 5.15905 15.3563 3.81258 14.2313 2.68758C13.1063 1.56253 11.76 1 10.1916 1C8.62326 1 7.27665 1.56253 6.15178 2.68753C5.02673 3.81258 4.46439 5.15901 4.46439 6.72721V9.18189H4.05536C3.71456 9.18189 3.42472 9.30113 3.18607 9.53979C2.94741 9.77827 2.82812 10.0681 2.82812 10.4092V17.7728C2.82812 18.1136 2.94745 18.4035 3.18607 18.6422C3.42472 18.8806 3.71456 19 4.05536 19H16.3278C16.6689 19 16.9585 18.8808 17.1973 18.6422C17.4357 18.4035 17.5552 18.1136 17.5552 17.7728V10.4091C17.5554 10.0682 17.4357 9.77845 17.1969 9.53979ZM13.4643 9.18189H6.91894V6.72721C6.91894 5.82384 7.2386 5.05248 7.87778 4.41339C8.51705 3.77421 9.28828 3.45468 10.1917 3.45468C11.0953 3.45468 11.8663 3.77416 12.5056 4.41339C13.1446 5.05244 13.4643 5.82384 13.4643 6.72721V9.18189Z" fill="white" />
                                    </svg>
                                </Box>
                            )}
                        </Box>

                        {/* Number Grid */}
                        <Box className={styles.BetContainerM}>
                            {chunkedNumbers.map((row, rowIndex) => (
                                <Box key={rowIndex} className={styles.BetContainerRowM}>
                                    {row.map((num) => (
                                        <Box
                                            key={num}
                                            className={blackNumbers.includes(num)
                                                ? styles.BetContainerRecordBlackM
                                                : styles.BetContainerRecordRedM}
                                            onClick={(e) => handlePlaceBet(e, num)}
                                            sx={{
                                                position: 'relative',
                                                cursor: locked ? 'not-allowed' : 'pointer',
                                                opacity: locked ? 0.7 : 1,
                                            }}
                                        >
                                            <Typography className={styles.BetContainerNoTextM}>{num}</Typography>
                                         {!isResultWindow && visibleBets.map(bet => renderBetChip(bet, num))}
                                            {locked && (
                                                <Box className={styles.bettinglocked_icon_container}>
                                                    <svg xmlns="http://www.w3.org/2000/svg" width="21" height="20" viewBox="0 0 21 20" fill="none">
                                                        <path d="M17.1969 9.53979C16.9582 9.30113 16.6686 9.18189 16.3275 9.18189H15.9187V6.72721C15.9187 5.15905 15.3563 3.81258 14.2313 2.68758C13.1063 1.56253 11.76 1 10.1916 1C8.62326 1 7.27665 1.56253 6.15178 2.68753C5.02673 3.81258 4.46439 5.15901 4.46439 6.72721V9.18189H4.05536C3.71456 9.18189 3.42472 9.30113 3.18607 9.53979C2.94741 9.77827 2.82812 10.0681 2.82812 10.4092V17.7728C2.82812 18.1136 2.94745 18.4035 3.18607 18.6422C3.42472 18.8806 3.71456 19 4.05536 19H16.3278C16.6689 19 16.9585 18.8808 17.1973 18.6422C17.4357 18.4035 17.5552 18.1136 17.5552 17.7728V10.4091C17.5554 10.0682 17.4357 9.77845 17.1969 9.53979ZM13.4643 9.18189H6.91894V6.72721C6.91894 5.82384 7.2386 5.05248 7.87778 4.41339C8.51705 3.77421 9.28828 3.45468 10.1917 3.45468C11.0953 3.45468 11.8663 3.77416 12.5056 4.41339C13.1446 5.05244 13.4643 5.82384 13.4643 6.72721V9.18189Z" fill="white" />
                                                    </svg>
                                                </Box>
                                            )}
                                        </Box>
                                    ))}
                                </Box>
                            ))}
                        </Box>

                        {/* 2 to 1 Columns */}
                        <Box className={styles.RowContainerM}>
                            {twoToOne.map((text, idx) => (
                                <Box
                                    key={idx}
                                    className={styles.RowCellBoxM}
                                    onClick={(e) => handleOutsideBet(e, `column${idx + 1}`)}
                                    sx={{
                                        position: 'relative',
                                        cursor: locked ? 'not-allowed' : 'pointer',
                                        opacity: locked ? 0.7 : 1
                                    }}
                                >
                                    <Typography className={styles.RowCellTextM}>{text}</Typography>
                           {!isResultWindow && visibleBets.map((bet) => renderOutsideChip(bet, `column${idx + 1}`))}
                                    {locked && (
                                        <Box className={styles.bettinglocked_icon_container}>
                                            <svg xmlns="http://www.w3.org/2000/svg" width="21" height="20" viewBox="0 0 21 20" fill="none">
                                                <path d="M17.1969 9.53979C16.9582 9.30113 16.6686 9.18189 16.3275 9.18189H15.9187V6.72721C15.9187 5.15905 15.3563 3.81258 14.2313 2.68758C13.1063 1.56253 11.76 1 10.1916 1C8.62326 1 7.27665 1.56253 6.15178 2.68753C5.02673 3.81258 4.46439 5.15901 4.46439 6.72721V9.18189H4.05536C3.71456 9.18189 3.42472 9.30113 3.18607 9.53979C2.94741 9.77827 2.82812 10.0681 2.82812 10.4092V17.7728C2.82812 18.1136 2.94745 18.4035 3.18607 18.6422C3.42472 18.8806 3.71456 19 4.05536 19H16.3278C16.6689 19 16.9585 18.8808 17.1973 18.6422C17.4357 18.4035 17.5552 18.1136 17.5552 17.7728V10.4091C17.5554 10.0682 17.4357 9.77845 17.1969 9.53979ZM13.4643 9.18189H6.91894V6.72721C6.91894 5.82384 7.2386 5.05248 7.87778 4.41339C8.51705 3.77421 9.28828 3.45468 10.1917 3.45468C11.0953 3.45468 11.8663 3.77416 12.5056 4.41339C13.1446 5.05244 13.4643 5.82384 13.4643 6.72721V9.18189Z" fill="white" />
                                            </svg>
                                        </Box>
                                    )}
                                </Box>
                            ))}
                        </Box>
                    </Box>
             ) : (
    <Box sx={{ display: 'flex', flexDirection: 'column', width: '100%', alignSelf: 'stretch' }}>

        {/* Row 1: spacer (matches sidebar width) + Zero box — sidebar does NOT extend up here */}
        <Box sx={{ display: 'flex', flexDirection: 'row' }}>
            <Box sx={{ width: '96px', flexShrink: 0 }} />
            <Box
                className={styles.zeroBox}
                onClick={(e) => handleOutsideBet(e, 'zero')}
                sx={{ flex: 1, position: 'relative', cursor: locked ? 'not-allowed' : 'pointer', opacity: locked ? 0.7 : 1 }}
            >
                {zero.map((num, idx) => (
                    <Typography key={idx} className={styles.zeroText}>{num}</Typography>
                ))}
              {!isResultWindow && visibleBets.map((bet) => renderOutsideChip(bet, 'zero'))}
                {locked && (
                    <Box className={styles.bettinglocked_icon_containerzeroBox}>
                        <svg xmlns="http://www.w3.org/2000/svg" width="21" height="20" viewBox="0 0 21 20" fill="none">
                            <path d="M17.1969 9.53979C16.9582 9.30113 16.6686 9.18189 16.3275 9.18189H15.9187V6.72721C15.9187 5.15905 15.3563 3.81258 14.2313 2.68758C13.1063 1.56253 11.76 1 10.1916 1C8.62326 1 7.27665 1.56253 6.15178 2.68753C5.02673 3.81258 4.46439 5.15901 4.46439 6.72721V9.18189H4.05536C3.71456 9.18189 3.42472 9.30113 3.18607 9.53979C2.94741 9.77827 2.82812 10.0681 2.82812 10.4092V17.7728C2.82812 18.1136 2.94745 18.4035 3.18607 18.6422C3.42472 18.8806 3.71456 19 4.05536 19H16.3278C16.6689 19 16.9585 18.8808 17.1973 18.6422C17.4357 18.4035 17.5552 18.1136 17.5552 17.7728V10.4091C17.5554 10.0682 17.4357 9.77845 17.1969 9.53979ZM13.4643 9.18189H6.91894V6.72721C6.91894 5.82384 7.2386 5.05248 7.87778 4.41339C8.51705 3.77421 9.28828 3.45468 10.1917 3.45468C11.0953 3.45468 11.8663 3.77416 12.5056 4.41339C13.1446 5.05244 13.4643 5.82384 13.4643 6.72721V9.18189Z" fill="white" />
                        </svg>
                    </Box>
                )}
            </Box>
        </Box>

        {/* Row 2: LEFT SIDEBAR — Dozens + (1-18/Even/Red/Black/Odd/19-36) — aligned exactly with the 12 number rows */}
        <Box sx={{ display: 'flex', flexDirection: 'row' }}>
            <Box className={styles.LeftSidebarRow}>
                <Box className={styles.LeftSidebarNarrow}>
                    {[
                        { label: '1 to 18', key: 'low' },
                        { label: 'EVEN', key: 'even' },
                        { label: 'RED', key: 'red', boxClass: styles.LeftSidebarCellRed, textClass: styles.LeftSidebarCellTextRed },
                        { label: 'BLACK', key: 'black', boxClass: styles.LeftSidebarCellBlack, textClass: styles.LeftSidebarCellTextRed },
                        { label: 'ODD', key: 'odd' },
                        { label: '19 to 36', key: 'high' },
                    ].map((item, idx) => (
                        <Box
                            key={idx}
                            className={item.boxClass || styles.LeftSidebarCell}
                            onClick={(e) => handleOutsideBet(e, item.key)}
                            sx={{
                                position: 'relative',
                                cursor: locked ? 'not-allowed' : 'pointer',
                                opacity: locked ? 0.7 : 1
                            }}
                        >
<Typography className={styles.LeftSidebarTextVertical}>{item.label}</Typography>
                          {!isResultWindow && visibleBets.map((bet) => renderOutsideChip(bet, item.key))}
                            {locked && (
                                <Box className={styles.bettinglocked_icon_container}>
                                    <svg xmlns="http://www.w3.org/2000/svg" width="21" height="20" viewBox="0 0 21 20" fill="none">
                                        <path d="M17.1969 9.53979C16.9582 9.30113 16.6686 9.18189 16.3275 9.18189H15.9187V6.72721C15.9187 5.15905 15.3563 3.81258 14.2313 2.68758C13.1063 1.56253 11.76 1 10.1916 1C8.62326 1 7.27665 1.56253 6.15178 2.68753C5.02673 3.81258 4.46439 5.15901 4.46439 6.72721V9.18189H4.05536C3.71456 9.18189 3.42472 9.30113 3.18607 9.53979C2.94741 9.77827 2.82812 10.0681 2.82812 10.4092V17.7728C2.82812 18.1136 2.94745 18.4035 3.18607 18.6422C3.42472 18.8806 3.71456 19 4.05536 19H16.3278C16.6689 19 16.9585 18.8808 17.1973 18.6422C17.4357 18.4035 17.5552 18.1136 17.5552 17.7728V10.4091C17.5554 10.0682 17.4357 9.77845 17.1969 9.53979ZM13.4643 9.18189H6.91894V6.72721C6.91894 5.82384 7.2386 5.05248 7.87778 4.41339C8.51705 3.77421 9.28828 3.45468 10.1917 3.45468C11.0953 3.45468 11.8663 3.77416 12.5056 4.41339C13.1446 5.05244 13.4643 5.82384 13.4643 6.72721V9.18189Z" fill="white" />
                                    </svg>
                                </Box>
                            )}
                        </Box>
                    ))}
                </Box>

                <Box className={styles.LeftSidebarDozen}>
                    {dozens.map((d, idx) => (
                        <Box
                            key={idx}
                            className={styles.LeftSidebarDozenCell}
                            onClick={(e) => handleOutsideBet(e, `dozen${idx + 1}`)}
                            sx={{
                                position: 'relative',
                                cursor: locked ? 'not-allowed' : 'pointer',
                                opacity: locked ? 0.7 : 1
                            }}
                        >
                           <Typography className={styles.LeftSidebarTextVertical}>{d.top}{d.bottom}</Typography>
                      {!isResultWindow && visibleBets.map((bet) => renderOutsideChip(bet, `dozen${idx + 1}`))}
                            {locked && (
                                <Box className={styles.bettinglocked_icon_container}>
                                    <svg xmlns="http://www.w3.org/2000/svg" width="21" height="20" viewBox="0 0 21 20" fill="none">
                                        <path d="M17.1969 9.53979C16.9582 9.30113 16.6686 9.18189 16.3275 9.18189H15.9187V6.72721C15.9187 5.15905 15.3563 3.81258 14.2313 2.68758C13.1063 1.56253 11.76 1 10.1916 1C8.62326 1 7.27665 1.56253 6.15178 2.68753C5.02673 3.81258 4.46439 5.15901 4.46439 6.72721V9.18189H4.05536C3.71456 9.18189 3.42472 9.30113 3.18607 9.53979C2.94741 9.77827 2.82812 10.0681 2.82812 10.4092V17.7728C2.82812 18.1136 2.94745 18.4035 3.18607 18.6422C3.42472 18.8806 3.71456 19 4.05536 19H16.3278C16.6689 19 16.9585 18.8808 17.1973 18.6422C17.4357 18.4035 17.5552 18.1136 17.5552 17.7728V10.4091C17.5554 10.0682 17.4357 9.77845 17.1969 9.53979ZM13.4643 9.18189H6.91894V6.72721C6.91894 5.82384 7.2386 5.05248 7.87778 4.41339C8.51705 3.77421 9.28828 3.45468 10.1917 3.45468C11.0953 3.45468 11.8663 3.77416 12.5056 4.41339C13.1446 5.05244 13.4643 5.82384 13.4643 6.72721V9.18189Z" fill="white" />
                                    </svg>
                                </Box>
                            )}
                        </Box>
                    ))}
                </Box>
            </Box>

            <Box className={styles.BetContainer} sx={{ flex: 1 }}>
                {chunkedNumbers.map((row, rowIndex) => (
                    <Box key={rowIndex} className={styles.BetContainerRow}>
                        {row.map((num) => (
                            <Box
                                key={num}
                                className={blackNumbers.includes(num) ? styles.BetContainerRecordBlack : styles.BetContainerRecordRed}
                                onClick={(e) => handlePlaceBet(e, num)}
                                sx={{ position: 'relative', cursor: locked ? 'not-allowed' : 'pointer', opacity: locked ? 0.7 : 1 }}
                            >
                                <Typography className={styles.BetContainerNoText}>{num}</Typography>
                           {!isResultWindow && visibleBets.map(bet => renderBetChip(bet, num))}
                                {locked && (
                                    <Box className={styles.bettinglocked_icon_container}>
                                        <svg xmlns="http://www.w3.org/2000/svg" width="21" height="20" viewBox="0 0 21 20" fill="none">
                                            <path d="M17.1969 9.53979C16.9582 9.30113 16.6686 9.18189 16.3275 9.18189H15.9187V6.72721C15.9187 5.15905 15.3563 3.81258 14.2313 2.68758C13.1063 1.56253 11.76 1 10.1916 1C8.62326 1 7.27665 1.56253 6.15178 2.68753C5.02673 3.81258 4.46439 5.15901 4.46439 6.72721V9.18189H4.05536C3.71456 9.18189 3.42472 9.30113 3.18607 9.53979C2.94741 9.77827 2.82812 10.0681 2.82812 10.4092V17.7728C2.82812 18.1136 2.94745 18.4035 3.18607 18.6422C3.42472 18.8806 3.71456 19 4.05536 19H16.3278C16.6689 19 16.9585 18.8808 17.1973 18.6422C17.4357 18.4035 17.5552 18.1136 17.5552 17.7728V10.4091C17.5554 10.0682 17.4357 9.77845 17.1969 9.53979ZM13.4643 9.18189H6.91894V6.72721C6.91894 5.82384 7.2386 5.05248 7.87778 4.41339C8.51705 3.77421 9.28828 3.45468 10.1917 3.45468C11.0953 3.45468 11.8663 3.77416 12.5056 4.41339C13.1446 5.05244 13.4643 5.82384 13.4643 6.72721V9.18189Z" fill="white" />
                                        </svg>
                                    </Box>
                                )}
                            </Box>
                        ))}
                    </Box>
                ))}
            </Box>
        </Box>

        {/* Row 3: spacer (matches sidebar width) + 2 to 1 row — sidebar does NOT extend down here */}
        <Box sx={{ display: 'flex', flexDirection: 'row' }}>
            <Box sx={{ width: '96px', flexShrink: 0 }} />
            <Box className={styles.RowContainer} sx={{ flex: 1 }}>
                {twoToOne.map((text, idx) => (
                    <Box
                        key={idx}
                        className={styles.RowCellBox}
                        onClick={(e) => handleOutsideBet(e, `column${idx + 1}`)}
                        sx={{ position: 'relative', cursor: locked ? 'not-allowed' : 'pointer', opacity: locked ? 0.7 : 1 }}
                    >
                        <Typography className={styles.RowCellText}>{text}</Typography>
                        {!isResultWindow && visibleBets.map((bet) => renderOutsideChip(bet, `column${idx + 1}`))}
                        {locked && (
                            <Box className={styles.bettinglocked_icon_container}>
                                <svg xmlns="http://www.w3.org/2000/svg" width="21" height="20" viewBox="0 0 21 20" fill="none">
                                    <path d="M17.1969 9.53979C16.9582 9.30113 16.6686 9.18189 16.3275 9.18189H15.9187V6.72721C15.9187 5.15905 15.3563 3.81258 14.2313 2.68758C13.1063 1.56253 11.76 1 10.1916 1C8.62326 1 7.27665 1.56253 6.15178 2.68753C5.02673 3.81258 4.46439 5.15901 4.46439 6.72721V9.18189H4.05536C3.71456 9.18189 3.42472 9.30113 3.18607 9.53979C2.94741 9.77827 2.82812 10.0681 2.82812 10.4092V17.7728C2.82812 18.1136 2.94745 18.4035 3.18607 18.6422C3.42472 18.8806 3.71456 19 4.05536 19H16.3278C16.6689 19 16.9585 18.8808 17.1973 18.6422C17.4357 18.4035 17.5552 18.1136 17.5552 17.7728V10.4091C17.5554 10.0682 17.4357 9.77845 17.1969 9.53979ZM13.4643 9.18189H6.91894V6.72721C6.91894 5.82384 7.2386 5.05248 7.87778 4.41339C8.51705 3.77421 9.28828 3.45468 10.1917 3.45468C11.0953 3.45468 11.8663 3.77416 12.5056 4.41339C13.1446 5.05244 13.4643 5.82384 13.4643 6.72721V9.18189Z" fill="white" />
                                </svg>
                            </Box>
                        )}
                    </Box>
                ))}
            </Box>
        </Box>
    </Box>
)}

                {/* Outside Bets Area — large screen only. Mobile duplicate removed (now lives in left sidebar above). */}
                {isLargeScreen ? (
                    <Box className={styles.MediaBox2}>
                        {/* Dozens */}
                        <Box className={styles.RowContainer2M}>
                            {dozens.map((d, idx) => (
                                <Box
                                    key={idx}
                                    className={styles.RowCellBox2M}
                                    onClick={(e) => handleOutsideBet(e, `dozen${idx + 1}`)}
                                    sx={{
                                        position: 'relative',
                                        cursor: locked ? 'not-allowed' : 'pointer',
                                        opacity: locked ? 0.7 : 1
                                    }}
                                >
                                    <Typography className={styles.RowCellTextM}>{d.top}</Typography>
                                    <Typography className={styles.RowCellTextM}>{d.bottom}</Typography>
                                   {!isResultWindow && visibleBets.map((bet) => renderOutsideChip(bet, `dozen${idx + 1}`))}
                                    {locked && (
                                        <Box className={styles.bettinglocked_icon_container}>
                                            <svg xmlns="http://www.w3.org/2000/svg" width="21" height="20" viewBox="0 0 21 20" fill="none">
                                                <path d="M17.1969 9.53979C16.9582 9.30113 16.6686 9.18189 16.3275 9.18189H15.9187V6.72721C15.9187 5.15905 15.3563 3.81258 14.2313 2.68758C13.1063 1.56253 11.76 1 10.1916 1C8.62326 1 7.27665 1.56253 6.15178 2.68753C5.02673 3.81258 4.46439 5.15901 4.46439 6.72721V9.18189H4.05536C3.71456 9.18189 3.42472 9.30113 3.18607 9.53979C2.94741 9.77827 2.82812 10.0681 2.82812 10.4092V17.7728C2.82812 18.1136 2.94745 18.4035 3.18607 18.6422C3.42472 18.8806 3.71456 19 4.05536 19H16.3278C16.6689 19 16.9585 18.8808 17.1973 18.6422C17.4357 18.4035 17.5552 18.1136 17.5552 17.7728V10.4091C17.5554 10.0682 17.4357 9.77845 17.1969 9.53979ZM13.4643 9.18189H6.91894V6.72721C6.91894 5.82384 7.2386 5.05248 7.87778 4.41339C8.51705 3.77421 9.28828 3.45468 10.1917 3.45468C11.0953 3.45468 11.8663 3.77416 12.5056 4.41339C13.1446 5.05244 13.4643 5.82384 13.4643 6.72721V9.18189Z" fill="white" />
                                            </svg>
                                        </Box>
                                    )}
                                </Box>
                            ))}
                        </Box>

                        {/* Low/Even | Red/Black | Odd/High */}
                        <Box sx={{ display: 'flex', flexDirection: 'row', alignSelf: 'stretch' }}>
                            <Box className={styles.RowContainer3M}>
                                {row3.map((text, idx) => (
                                    <Box
                                        key={idx}
                                        className={styles.RowCellBox3M}
                                        onClick={(e) => handleOutsideBet(e, idx === 0 ? 'low' : 'even')}
                                        sx={{
                                            position: 'relative',
                                            cursor: locked ? 'not-allowed' : 'pointer',
                                            opacity: locked ? 0.7 : 1
                                        }}
                                    >
                                        <Typography className={styles.RowCellTextM}>{text}</Typography>
                                        {!isResultWindow && visibleBets.map((bet) => renderOutsideChip(bet, idx === 0 ? 'low' : 'even'))}
                                        {locked && (
                                            <Box className={styles.bettinglocked_icon_container}>
                                                <svg xmlns="http://www.w3.org/2000/svg" width="21" height="20" viewBox="0 0 21 20" fill="none">
                                                    <path d="M17.1969 9.53979C16.9582 9.30113 16.6686 9.18189 16.3275 9.18189H15.9187V6.72721C15.9187 5.15905 15.3563 3.81258 14.2313 2.68758C13.1063 1.56253 11.76 1 10.1916 1C8.62326 1 7.27665 1.56253 6.15178 2.68753C5.02673 3.81258 4.46439 5.15901 4.46439 6.72721V9.18189H4.05536C3.71456 9.18189 3.42472 9.30113 3.18607 9.53979C2.94741 9.77827 2.82812 10.0681 2.82812 10.4092V17.7728C2.82812 18.1136 2.94745 18.4035 3.18607 18.6422C3.42472 18.8806 3.71456 19 4.05536 19H16.3278C16.6689 19 16.9585 18.8808 17.1973 18.6422C17.4357 18.4035 17.5552 18.1136 17.5552 17.7728V10.4091C17.5554 10.0682 17.4357 9.77845 17.1969 9.53979ZM13.4643 9.18189H6.91894V6.72721C6.91894 5.82384 7.2386 5.05248 7.87778 4.41339C8.51705 3.77421 9.28828 3.45468 10.1917 3.45468C11.0953 3.45468 11.8663 3.77416 12.5056 4.41339C13.1446 5.05244 13.4643 5.82384 13.4643 6.72721V9.18189Z" fill="white" />
                                                </svg>
                                            </Box>
                                        )}
                                    </Box>
                                ))}
                            </Box>

                            <Box className={styles.RowContainer4M}>
                                {row4.map((item, idx) => (
                                    <Box
                                        key={idx}
                                        className={item.boxClass}
                                        onClick={(e) => handleOutsideBet(e, idx === 0 ? 'red' : 'black')}
                                        sx={{
                                            position: 'relative',
                                            cursor: locked ? 'not-allowed' : 'pointer',
                                            opacity: locked ? 0.7 : 1
                                        }}
                                    >
                                        <Typography className={styles.RowCellBox4TextM}>{item.label}</Typography>
                                     {!isResultWindow && visibleBets.map((bet) => renderOutsideChip(bet, idx === 0 ? 'red' : 'black'))}
                                        {locked && (
                                            <Box className={styles.bettinglocked_icon_container}>
                                                <svg xmlns="http://www.w3.org/2000/svg" width="21" height="20" viewBox="0 0 21 20" fill="none">
                                                    <path d="M17.1969 9.53979C16.9582 9.30113 16.6686 9.18189 16.3275 9.18189H15.9187V6.72721C15.9187 5.15905 15.3563 3.81258 14.2313 2.68758C13.1063 1.56253 11.76 1 10.1916 1C8.62326 1 7.27665 1.56253 6.15178 2.68753C5.02673 3.81258 4.46439 5.15901 4.46439 6.72721V9.18189H4.05536C3.71456 9.18189 3.42472 9.30113 3.18607 9.53979C2.94741 9.77827 2.82812 10.0681 2.82812 10.4092V17.7728C2.82812 18.1136 2.94745 18.4035 3.18607 18.6422C3.42472 18.8806 3.71456 19 4.05536 19H16.3278C16.6689 19 16.9585 18.8808 17.1973 18.6422C17.4357 18.4035 17.5552 18.1136 17.5552 17.7728V10.4091C17.5554 10.0682 17.4357 9.77845 17.1969 9.53979ZM13.4643 9.18189H6.91894V6.72721C6.91894 5.82384 7.2386 5.05248 7.87778 4.41339C8.51705 3.77421 9.28828 3.45468 10.1917 3.45468C11.0953 3.45468 11.8663 3.77416 12.5056 4.41339C13.1446 5.05244 13.4643 5.82384 13.4643 6.72721V9.18189Z" fill="white" />
                                                </svg>
                                            </Box>
                                        )}
                                    </Box>
                                ))}
                            </Box>

                            <Box className={styles.RowContainer5M}>
                                {row5.map((item, idx) => (
                                    <Box
                                        key={idx}
                                        className={item.boxClass}
                                        onClick={(e) => handleOutsideBet(e, idx === 0 ? 'odd' : 'high')}
                                        sx={{
                                            position: 'relative',
                                            cursor: locked ? 'not-allowed' : 'pointer',
                                            opacity: locked ? 0.7 : 1
                                        }}
                                    >
                                        <Typography className={styles.RowCellBox5TextM}>{item.label}</Typography>
                                {!isResultWindow && visibleBets.map((bet) => renderOutsideChip(bet, idx === 0 ? 'odd' : 'high'))}
                                        {locked && (
                                            <Box className={styles.bettinglocked_icon_container}>
                                                <svg xmlns="http://www.w3.org/2000/svg" width="21" height="20" viewBox="0 0 21 20" fill="none">
                                                    <path d="M17.1969 9.53979C16.9582 9.30113 16.6686 9.18189 16.3275 9.18189H15.9187V6.72721C15.9187 5.15905 15.3563 3.81258 14.2313 2.68758C13.1063 1.56253 11.76 1 10.1916 1C8.62326 1 7.27665 1.56253 6.15178 2.68753C5.02673 3.81258 4.46439 5.15901 4.46439 6.72721V9.18189H4.05536C3.71456 9.18189 3.42472 9.30113 3.18607 9.53979C2.94741 9.77827 2.82812 10.0681 2.82812 10.4092V17.7728C2.82812 18.1136 2.94745 18.4035 3.18607 18.6422C3.42472 18.8806 3.71456 19 4.05536 19H16.3278C16.6689 19 16.9585 18.8808 17.1973 18.6422C17.4357 18.4035 17.5552 18.1136 17.5552 17.7728V10.4091C17.5554 10.0682 17.4357 9.77845 17.1969 9.53979ZM13.4643 9.18189H6.91894V6.72721C6.91894 5.82384 7.2386 5.05248 7.87778 4.41339C8.51705 3.77421 9.28828 3.45468 10.1917 3.45468C11.0953 3.45468 11.8663 3.77416 12.5056 4.41339C13.1446 5.05244 13.4643 5.82384 13.4643 6.72721V9.18189Z" fill="white" />
                                                </svg>
                                            </Box>
                                        )}
                                    </Box>
                                ))}
                            </Box>
                        </Box>
                    </Box>
                ) : null}
            </Box>

            <ResultsScreen />
        </Box>
        </RoundLoader>
    );
}

export default Roulette;